import React from "react"
import { PageInfoProps } from "../../../utils/geleral-types"
import LeaveAccrualList from "../../leave/leave-accrual/leave-accrual-list.tsx"

function LeaveInformation({ employeeId }: PageInfoProps) {
    return (
        
        <React.Fragment>
            <LeaveAccrualList employeeId={employeeId} />
        </React.Fragment>
    )
}

export default LeaveInformation